import { Flex, Heading, useMediaQuery } from '@chakra-ui/react'
import {
  ConnectedFormGroup,
  ConnectedImageUploader,
  ConnectedPasswordGroup
} from 'components/FormElements'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaIdCard } from 'react-icons/fa'
import { VscMail } from 'react-icons/vsc'

const SuperAdminInfo: React.FC = () => {
  const { t } = useTranslation()
  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
  return (
    <>
      <Heading my={2} size="lg" textAlign="left">
        {t('signup.agency.admin_info')}
      </Heading>
      <Flex direction={isTabletOrMobile ? 'column' : 'row'}>
        <ConnectedFormGroup
          mr={isTabletOrMobile ? 0 : 2}
          flex={1}
          name="adminFirstName"
          label={t('signup.agency.first_name_label')}
          placeholder="e.g: John"
        />
        <ConnectedFormGroup
          name="adminLastName"
          flex={1}
          label={t('signup.agency.last_name_label')}
          placeholder="e.g: Doe"
        />
      </Flex>
      <Flex direction={isTabletOrMobile ? 'column' : 'row'}>
        <ConnectedFormGroup
          name="adminEmail"
          mr={isTabletOrMobile ? 0 : 2}
          flex={1}
          leftIcon={VscMail}
          label="Email"
          placeholder="e.g: support@nsoko.io"
        />
        <ConnectedFormGroup
          name="adminPhone"
          label={t('signup.agency.phone_number_label')}
          flex={1}
          maxLength={10}
          placeholder="e.g: 08198765432"
        />
      </Flex>
      <ConnectedFormGroup
        name="adminAgentNumber"
        label={t('signup.agency.agent_number')}
        leftIcon={FaIdCard}
        placeholder="1234567890"
        maxLength={10}
      />
      <Flex mt={4} direction={isTabletOrMobile ? 'column' : 'row'}>
        <ConnectedPasswordGroup
          name="adminPassword"
          isRequired
          width="100%"
          mr={isTabletOrMobile ? 0 : 2}
          label={t('signup.agency.password_label')}
          placeholder="Password"
        />
        <ConnectedPasswordGroup
          name="adminConfirmPassword"
          label={t('signup.agency.password_confirm_label')}
          width="100%"
          isRequired
          placeholder="Confirm Password"
        />
      </Flex>

      <ConnectedImageUploader label="Photo" name="adminProfilePicture" />
    </>
  )
}

export default SuperAdminInfo
